import { type ContentObjectRedux } from 'models';
import { canLikeContentObject } from './canLikeContentObject';

export const canSeeContentObjectLikes = ({ contentObject }: { contentObject: ContentObjectRedux }) =>
  canLikeContentObject({ contentObject });
